import { render, staticRenderFns } from "./WeserveADS.vue?vue&type=template&id=f31a787a&scoped=true"
import script from "./WeserveADS.vue?vue&type=script&lang=js"
export * from "./WeserveADS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31a787a",
  null
  
)

export default component.exports